export default {
  user(state) {
    return state.user;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  currentTheme(state) {
    return state.theme || "dark";
  },
  isAdmin(state) {
    return !!state.isAdmin;
  },
  // Usage: this.$store.getters.can('about.create'), or the `can(name)`
  // component method every About/Blog/Recycle-bin view exposes so templates
  // can write v-if="can('about.create')" directly.
  can(state) {
    return (name) => !!state.isAdmin || (state.permissions || []).includes(name);
  },
};
